const component = "select-section-parent-dialog";

export const selectSectionParentDialog = {
  component,
  closeButton: `${component}/close-button`,
  targetSectionName: `${component}/target-section-name`,
  targetSiteRoot: `${component}/target-site-root`,
  chooseButton: `${component}/choose-button`,
};
